"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScatterChartOptions = void 0;

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var getScatterChartOptions = function getScatterChartOptions(data, height, minX, maxX, minY, maxY, xLabels, yLabels, tooltipFormat) {
  function tooltipFormatter() {
    return "".concat(tooltipFormat(this.series.name, this.x, this.y));
  }

  function tickPositionerX() {
    var diff = maxX - minX;
    return _toConsumableArray(Array(_constants.tickLength).keys()).map(function (k) {
      return diff / (_constants.tickLength - 1) * k + minX;
    });
  }

  function tickPositionerY() {
    var diff = maxY - minY;
    return _toConsumableArray(Array(_constants.tickLength).keys()).map(function (k) {
      return diff / (_constants.tickLength - 1) * k + minY;
    });
  }

  return _objectSpread(_objectSpread({}, _constants.defaultScatterChartOptions), {}, {
    chart: _objectSpread(_objectSpread({}, _constants.defaultScatterChartOptions.chart), {}, {
      height: height,
      width: height
    }),
    xAxis: _objectSpread(_objectSpread({}, _constants.defaultScatterChartOptions.xAxis), {}, {
      min: minX,
      max: maxX,
      tickPositioner: tickPositionerX
    }),
    yAxis: _objectSpread(_objectSpread({}, _constants.defaultScatterChartOptions.yAxis), {}, {
      min: minY,
      max: maxY,
      tickPositioner: tickPositionerY
    }),
    tooltip: _objectSpread(_objectSpread({}, _constants.defaultScatterChartOptions.tooltip), {}, {
      formatter: tooltipFormatter
    }),
    series: _toConsumableArray(data)
  });
};

exports.getScatterChartOptions = getScatterChartOptions;